module.exports = __webpack_public_path__ + "img/return.a33f8bbf.png";